import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Mind's Eye — FTUE demo (3 essais).
 *
 * E1 : F → F (rotation 0°), identique
 * E2 : F → F miroir (rotation 0° + scaleX(-1))
 * E3 : R → R rotation 90°, identique
 */
import { useEffect, useRef, useState } from 'react';
const DEMO_STEPS = [
    {
        idx: 1,
        title: 'Essai 1 — identique',
        hint: 'Compare la 2e forme à la 1ère. Ici elles sont identiques.',
        shape: 'F',
        rotationDeg: 0,
        mirrored: false,
    },
    {
        idx: 2,
        title: 'Essai 2 — miroir',
        hint: "Cette fois la 2e est l'image miroir. Tape MIROIR.",
        shape: 'F',
        rotationDeg: 0,
        mirrored: true,
    },
    {
        idx: 3,
        title: 'Essai 3 — rotation 90°',
        hint: 'Tournée de 90° mais identique (pas miroir).',
        shape: 'R',
        rotationDeg: 90,
        mirrored: false,
    },
];
function ShapeGlyph({ shape, rotationDeg, mirrored, }) {
    const transform = `${mirrored ? 'scaleX(-1) ' : ''}rotate(${rotationDeg}deg)`;
    return (_jsx("span", { style: { transform, display: 'inline-block' }, className: "font-display text-[80px] leading-none text-cyan-text", children: shape }));
}
export function Demo({ onComplete, onSkip }) {
    const [stepIdx, setStepIdx] = useState(0);
    const [phase, setPhase] = useState('reference');
    const [picked, setPicked] = useState(null);
    const phaseTimer = useRef(null);
    const step = DEMO_STEPS[stepIdx];
    const isLast = stepIdx === DEMO_STEPS.length - 1;
    useEffect(() => {
        setPhase('reference');
        setPicked(null);
        phaseTimer.current = setTimeout(() => setPhase('gap'), 900);
        return () => {
            if (phaseTimer.current)
                clearTimeout(phaseTimer.current);
        };
    }, [stepIdx]);
    useEffect(() => {
        if (phase === 'gap') {
            phaseTimer.current = setTimeout(() => setPhase('comparison'), 350);
        }
        return () => {
            if (phaseTimer.current)
                clearTimeout(phaseTimer.current);
        };
    }, [phase]);
    const correct = (() => {
        if (phase !== 'feedback')
            return null;
        return (picked === 'mirror') === step.mirrored;
    })();
    const handlePick = (a) => {
        if (phase !== 'comparison')
            return;
        setPicked(a);
        setPhase('feedback');
    };
    const handleNext = () => {
        if (isLast) {
            onComplete();
            return;
        }
        setStepIdx((i) => i + 1);
    };
    return (_jsxs("div", { className: "flex flex-1 flex-col items-center gap-s4 py-s4 text-center", children: [_jsx("p", { className: "font-mono text-[9.5px] uppercase tracking-[0.30em] text-cyan-text-faint", children: "D\u00E9mo guid\u00E9e" }), _jsx("h2", { className: "font-display text-[22px] font-medium leading-7 tracking-cy-display text-cyan-text", children: step.title }), _jsx("p", { className: "max-w-[320px] text-[13.5px] text-cyan-text-secondary", children: step.hint }), _jsxs("div", { className: "relative flex h-[200px] w-full max-w-[320px] items-center justify-center border border-cyan-border-faint bg-cyan-surface", children: [phase === 'reference' && (_jsx(ShapeGlyph, { shape: step.shape, rotationDeg: 0, mirrored: false })), phase === 'gap' && (_jsx("span", { className: "font-display text-[24px] text-cyan-text-faint", children: "\u00B7" })), (phase === 'comparison' || phase === 'feedback') && (_jsx(ShapeGlyph, { shape: step.shape, rotationDeg: step.rotationDeg, mirrored: step.mirrored })), phase === 'feedback' && (_jsx("span", { className: [
                            'absolute inset-0 flex items-center justify-center font-display text-[28px] font-medium',
                            correct ? 'text-cyan-core' : 'text-cyan-media',
                        ].join(' '), style: { background: 'rgba(255,255,255,0.85)' }, children: correct ? '✓' : '✗' }))] }), _jsxs("div", { className: "flex flex-col items-stretch gap-s3 self-stretch", children: [phase === 'comparison' && (_jsxs("div", { className: "flex justify-center gap-s3", children: [_jsx("button", { type: "button", onClick: () => handlePick('identical'), "aria-label": "Identique", className: "inline-flex h-[56px] min-w-[110px] items-center justify-center bg-cyan-core px-s4 font-display text-[14px] font-medium tracking-[-0.01em] text-cyan-surface transition active:scale-[0.985] hover:bg-cyan-network", children: "Identique" }), _jsx("button", { type: "button", onClick: () => handlePick('mirror'), "aria-label": "Miroir", className: "inline-flex h-[56px] min-w-[110px] items-center justify-center border border-cyan-border bg-cyan-surface px-s4 font-display text-[14px] font-medium tracking-[-0.01em] text-cyan-text transition active:scale-[0.985] hover:bg-cyan-bg", children: "Miroir" })] })), phase === 'feedback' && (_jsx("button", { type: "button", onClick: handleNext, className: "inline-flex h-12 w-full items-center justify-center bg-cyan-core font-display text-[14px] font-medium tracking-[-0.01em] text-cyan-surface transition active:scale-[0.985] hover:bg-cyan-network", children: isLast ? 'Démarrer la session' : 'Essai suivant' })), _jsx("button", { type: "button", onClick: onSkip, className: "text-[12px] text-cyan-text-secondary underline-offset-4 hover:underline", children: "Passer la d\u00E9mo" })] })] }));
}
//# sourceMappingURL=demo.js.map